var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.58594C10.5 7.42188 10.3359 7.25781 10.1719 7.25781H7.49219V4.57812C7.49219 4.41406 7.32812 4.25 7.16406 4.25H6.83594C6.64453 4.25 6.50781 4.41406 6.50781 4.57812V7.25781H3.82812C3.63672 7.25781 3.5 7.42188 3.5 7.58594V7.91406C3.5 8.10547 3.63672 8.24219 3.82812 8.24219H6.50781V10.9219C6.50781 11.1133 6.64453 11.25 6.83594 11.25H7.16406C7.32812 11.25 7.49219 11.1133 7.49219 10.9219V8.24219H10.1719C10.3359 8.24219 10.5 8.10547 10.5 7.91406V7.58594ZM13.7812 7.75C13.7812 4.00391 10.7461 0.96875 7 0.96875C3.25391 0.96875 0.21875 4.00391 0.21875 7.75C0.21875 11.4961 3.25391 14.5312 7 14.5312C10.7461 14.5312 13.7812 11.4961 13.7812 7.75ZM12.9062 7.75C12.9062 11.0039 10.2539 13.6562 7 13.6562C3.74609 13.6562 1.09375 11.0312 1.09375 7.75C1.09375 4.52344 3.71875 1.84375 7 1.84375C10.2266 1.84375 12.9062 4.49609 12.9062 7.75Z",
    fill: "#0078B1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.d1af65d4581212e8af95d66b04e9cfb7.svg";
export { ForwardRef as ReactComponent };